import type { KeywordDefinition, SchemaValidateFunction } from 'ajv';
import { SingleSelectionProperty } from 'shared';
import { SingleSelectionValueForValidation } from 'validators/shared';

const KEYWORD = 'requiredSubtext';

const validate: SchemaValidateFunction = (
  schema: SingleSelectionProperty['requiredSubtext'],
  data: SingleSelectionValueForValidation
) => {
  if (!schema || !schema.length || typeof data.value !== 'number') {
    return true;
  }

  const requiredSubtext = schema.find(({ value }) => value === data.value);
  if (!requiredSubtext) {
    return true;
  }

  const { subtext } = data;
  if (typeof subtext === 'string' && subtext !== '') {
    return true;
  }
  validate.errors = [
    {
      keyword: KEYWORD,
      params: { keyword: KEYWORD },
      message: requiredSubtext.message,
    },
  ];
  return false;
};

export const requiredSubtext: KeywordDefinition = {
  keyword: KEYWORD,
  type: 'object',
  validate,
};
